import { gql } from 'graphql-request'
import { BlockFeatureList } from './block-feature-list'
import { BlockSummary } from './block-summary'
import { BlockFeatureSimple } from './block-feature-simple'
import { BlockIntegrationsFiltering } from './block-filter'
import { BlockTeamMembers } from './block-team-members'
import { BlockFeatureContact } from './block-feature-contact'
import { BlockPricingCards } from './block-pricing-cards'
import { BlockRequestForm } from './block-request-form'
import { BlockUspList } from './block-usp-list'
import { BlockLogos } from './block-logos'
import { BlockIntegrationListing } from './block-integration-listing'
import { Block3CardsWithImage } from './block-3-cards-with-image'
import { BlockHeroHomeTwo } from './block-hero-home-two'
import { BlockBenefitsListing } from './block-benefits-listing'
import { BlockCustomersTop } from './customers-top'
import { BlockCrissCross } from './block-crisscross'
import { BlockRelatedArticles } from './block-related-articles'
import { BlockSectionHeader } from './block-section-header'
import { BlockCta } from './block-cta'
import { BlockRichText } from './block-richtext'
import { BlockHeroDual } from './block-hero-dual'
import { Block2ColumnsIntegrationList } from './block-two-columns-integration'
import { BlockOffices } from './block-offices'
import { HubSpotCalendar } from './block-hubspot-calendar'
import { BlockFaqTop } from './block-faq-top'
import { BlockBlogTop } from './block-blog-top'
import { QueryNavigationItem } from './navigation-element'
import { QueryVideo } from './video'
import { QuerySimpleBlock } from './simple-block'
import { QueryFormattedTextBlock } from './formatted-text-block'
import { QueryFeatureCardBlock } from './feature-card-block'
import { QueryBenefitBlock } from './benefit-block'
import { QueryHubspotForm } from './hubspot-form'
import { QueryLogo } from './logos'
import { QueryTeamMember } from './team-member'
import { ResponsiveImage } from './responsive-image'
import { FragmentLinkReferences } from './references'

const modelArray = {
  BlockFeatureList,
  BlockSummary,
  BlockFeatureSimple,
  BlockIntegrationsFiltering,
  BlockTeamMembers,
  BlockFeatureContact,
  BlockPricingCards,
  BlockRequestForm,
  BlockUspList,
  BlockLogos,
  BlockIntegrationListing,
  Block3CardsWithImage,
  BlockHeroHomeTwo,
  BlockBenefitsListing,
  BlockCustomersTop,
  BlockCrissCross,
  BlockRelatedArticles,
  BlockSectionHeader,
  BlockCta,
  BlockRichText,
  BlockHeroDual,
  Block2ColumnsIntegrationList,
  BlockOffices,
  HubSpotCalendar,
  BlockFaqTop,
  BlockBlogTop,
}


const additionalFragments = [
  QueryNavigationItem,
  QueryVideo,
  QuerySimpleBlock,
  QueryFormattedTextBlock,
  QueryFeatureCardBlock,
  QueryBenefitBlock,
  QueryHubspotForm,
  QueryLogo,
  QueryTeamMember,
  ResponsiveImage,
  FragmentLinkReferences
].filter(Boolean).join('\n')

const fragmentQueries = Object.values(modelArray)
    .map(model => model.fragmentQuery)
    .filter(Boolean)
    .join('\n')

export const datoQueryHomepageContent = gql`
query marketQuery($locale: SiteLocale!, $slugPrefix: String!) {
  marketModel(locale: $locale, fallbackLocales: en, filter: {slugPrefix: {eq: $slugPrefix}}) {
    title
    pageTitlePrefix
    homepage {
      id
      title
      metaTags
      marketsMetaTags
      metaImage {
        url
      }
      components {
        ...FragmentBenefitBlock
        ...FragmentBlock3CardsWithImage
        ...FragmentBlockBenefitsListing
        ...FragmentBlockBlogTop
        ...FragmentBlockCrissCross
        ...FragmentBlockCta
        ...FragmentBlockFaqTop
        ...FragmentBlockFeatureContact
        ...FragmentBlockFeatureList
        ...FragmentBlockFeatureSimple
        ...FragmentBlockFiltering
        ...FragmentBlockHeroDual
        ...FragmentBlockHeroHomeTwo
        ...FragmentBlockHubSpotCalendar
        ...FragmentBlockIntegrationListing
        ...FragmentBlockLogos
        ...FragmentBlockOffices
        ...FragmentBlockPricingCards
        ...FragmentBlockRelatedArticles
        ...FragmentBlockRequestForm
        ...FragmentBlockRichText
        ...FragmentBlockSectionHeader
        ...FragmentBlockSummary
        ...FragmentBlockTeamMembers
        ...FragmentBlock2ColumnsIntegrationList
        ...FragmentBlockUspList
        ...FragmentBlockCustomersTop
        ...FragmentHubspotForm
        ...FragmentLogos
        ...FragmentBlockPricingCards
      }
    }
  }
}

  ${fragmentQueries}
  ${additionalFragments}
`